export const CALENDLY_OPTIONS = {
  url: 'https://calendly.com/amenti',
  pageSettings: {
    backgroundColor: 'fbfbfb',
    primaryColor: '3B5EB1',
    textColor: '1b2122',
  },
};
